<template>
    <div class="error-not-found">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="error-inner text-center">
                        <div class="image">
                            <img src="assets/img/icons/404.png" alt="404">
                        </div>
                        <h1 class="heading-h3 text-white">به نظر می رسد گم شده اید :)</h1>
                        <div class="error-text">
                            <p class="text-white">برگه ای که به دنیال آن می گردید، وجود ندارد.</p>
                            <div class="error-button-group">
                                <router-link class="btn-submit bg-wht" to="/">
                                    بازگشت به صفحه قبلی
                                </router-link>
                                <router-link class="btn-submit" to="/">
                                    بازگشت به خانه
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound'
    }
</script>
